<template>
  <div class="week-time-manager p-2">
    <h4 class="text-center">Manage time</h4>

    <!--
    <el-button type="primary" plain class="d-block w-100" @click="onGoBack">
      <i class="el-icon-back"></i> Go back
    </el-button>
    -->

    <template v-if="page_ready">

      <template v-if="timeslot_collection_list.length === 0">
        <div class="no-timeslot-info">
          You don't have a life area/timeslot collection defined yet.<br>
          <span style="font-size: 10pt">Create one with 'Add collection' &rarr; 'Add timeslot collection'.</span>
        </div>
      </template>

      <TimeslotCollectionMultiDragList mode="weekdaypref"/>

      <el-dropdown @command="handleDropdownCommand">
        <el-button type="primary" style="margin-right: 0.5em" class="d-block btn-block">
          Add schedule<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="addTimeslotCollection">
            <i class="el-icon-circle-plus-outline"></i> Add timeslot collection
          </el-dropdown-item>
          <el-dropdown-item command="connectGoogleCalendar" divided>
            <i class="el-icon-circle-plus-outline"></i> Connect google calendar
          </el-dropdown-item>
          <el-dropdown-item command="addSpecialTimeslotCollectionBlocker" divided>
            <i class="el-icon-circle-plus-outline"></i> Add blockers
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </template>
    <template v-else>
      <div class="content-loading">
        Loading...
      </div>
    </template>
  </div>
</template>

<script>
import TimeslotCollectionMultiDragList from './Timeslots/TimeslotCollectionMultiDragList';

export default {
  data: () => ({
    page_ready: true // HACK !!!
  }),
  mounted() {
    // setTimeout( () => { this.page_ready = true }, 2000) // HACK !!!!
  },
  computed: {
    timeslot_collection_list() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },
  },
  methods: {
    // onGoBack() {
    //   this.$router.push('/calendar/manage-time-and-priorities')
    // },

    connectGoogleCalendar() {
      console.log("connectGoogleCalendar");
      this.$api.timeslot_collection_add_to_user({
        tscType: 'GOOGLE',
        additionData: {
          // TODO FROM MODAL?
        }
      });
    },

    addSpecialTimeslotCollectionBlocker() {
      console.log("addSpecialTimeslotCollectionBlocker");
      this.$api.timeslot_collection_add_to_user({
        tscType: 'BLOCKER'
      });
    },

    addTimeslotCollection(event) {
      console.log("addTimeslotCollection", event);
      this.$api.timeslot_collection_add_to_user();
    },

    handleDropdownCommand(command) {
      this[command]();
    },
  },
  components: {
    TimeslotCollectionMultiDragList
  }
}
</script>

<style>
/* doppelt */
.week-time-manager .content-loading {
  height: 200px;
  line-height: 200px;
  font-weight: bold;
  text-align: center;
  color: gray;
}
</style>
